/**
 * 24-hour clock in every language: without it English shows "02:05 AM", while a fleet timeline
 * reads in 24-hour time everywhere else in the app.
 */
export const TIME_OPTIONS: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' };
